module.exports = __webpack_public_path__ + "static/media/teams.8e2fabb2.svg";